// extracted by mini-css-extract-plugin
module.exports = {"loading":"signup_loading__Kod5j","loadingDetailsSignup":"signup_loadingDetailsSignup__QSEO_","loadingCpfSignup":"signup_loadingCpfSignup__VHoLg"};